export default {
  cardOneTitle: '什么是融资购买力',
  cardOneDesc1: '融资购买力是代表您可下单买卖股票的金额',
  cardOneDesc2:
    '融资购买力将您在盈宝的各市场股票资产、各货币基金和各货币现金折算相加减成为一个通用、统一的购买力。',
  cardOneTips: '备注：融资购买力只可买卖股票，暂不可直接认购IPO和买入基金',

  cardTwoTitle: '我的融资购买力',
  cardTwoSubTitle1: '融资购买力构成',
  cardTwoSubTitle2: '净现金结余折算',
  cardTwoSubTitle3: '货币在途现金折算',
  cardTwoSubTitle4: '可抵押市值折算',
  cardTwoSubTitle5: '融资购买力合计',
  hkCash: '港元净现金结余',
  usCash: '美元净现金结余',
  hkZtBalancePlus: '港元在途余额+',
  usZtBalancePlus: '美元在途余额+',
  hkHoldBalancePlus: '港元持仓余额+',
  usHoldBalancePlus: '美元持仓余额+',
  when: '当',
  mortgageMarketValue: '可抵押市值',
  financingAmount: '融资额度',
  usedBuyPower: '已用购买力',
  cashOnHold: '待买入',
  financingPurchasingPower: '融资购买力',
  netCash: '净现金结余',
  balancePlusMortgageMarketValue: '余额+抵押市值',
  isMarketValueSmallTips: '融资购买力=（净现金结余）+（可抵押市值）+（余额+抵押市值）-（已用购买力）',
  isMarketValueBigTips: '融资购买力=（净现金结余）+（融资额度）-（待买入）',

  cardThreeTitle: '融资购买力使用场景',
  cardThreeDesc: '用户只有港股资产和港币，没有美元现金，想买入美股股票',
  cardThreeSubTitle1: '没有融资购买力之前：',
  cardThreeSubDesc1: '用户只能卖出港股并货币兑换成美元或者入金美元，买入美股',
  cardThreeSubTitle2: '有融资购买力之后：',
  cardThreeSubDesc2: '用户可直接买入美股。因为盈宝会直接帮客户把港股和港币折算成美元买入美股。',

  cardFourTitle: '什么是可抵押市值',
  cardFourDesc1: '可抵押市值代表客户持仓的港股市值，在盈宝可抵押多少金额额外增加融资购买力。',
  cardFourDesc2: '案例：<br/>如您持仓10,000HKD市值的腾讯，腾讯抵押率为50%，港币为0HKD，想买入4,000HKD小米。',
  cardFourDesc3: '则可抵押市值为 10,000*50%=5,000HKD',
  cardFourDesc4: '抵押出来的5,000HKD可用来买入小米。',

  cardFiveTitle: '为什么可抵押市值很高融资购买力却很少',
  cardFiveDesc1:
    '受融资额度限制，融资额度决定客户的最高融资限额，当融资额度比较小的时候，哪怕持仓可抵押市值很高，所能融资的额度也是会受到限制。',
  cardFiveDesc2:
    '案例：用户可抵押市值100万HKD，但是融资额度只有10万HKD在现金为0的情况下，客户的融资购买力也是只有10万，而非100万。',

  cardSixTitle: '实际可买入金额为什么会大于融资购买力',
  cardSixDesc1: '因为即将买入的股票也可继续抵押释放购买力。因此盈宝在计算时已经帮客户进行循环抵押融资。',
  cardSixDesc2:
    '在循环购买力的加持下，比如客户持有10,000HKD的融资购买力，买入抵押率75%的股票，那么实际最大可买金额为10,000/（1-75%）=40000HKD的股票，即是可直接下单40,000的买入订单。',

  cardSevenTitle: '如何知道有没有使用融资以及如何还款',
  cardSevenDesc1: '在账户明细页面查看“融资欠款”，如融资欠款>0，则代表您已使用融资;如融资欠款<0，则代表您没有融资。',
  cardSevenDesc2: '在资产首页-“融资”功能入口，也可查看融资欠款',
  cardSevenDesc3: '如何还款：您可存入对应欠款币种的现金，或进行货币兑换。',
  cardSevenTips: '注意:IPO融资和股票抵押融资是有区分的，盈宝暂未打通使用融资购买力融资认购IPO',

  cardEightTitle: '融资利息什么时候会扣款',
  cardEightDesc1: '融资利息是按照每天计算,在每个自然月最后一个交易日扣款。',
  cardEightDesc2: '客户可在"融资"或"账户明细"查看预计利息,了解当前的利息情况。'
}
